import React from "react"; // { useContext }
// import { AuthContext } from "../../context/Auth/AuthContext";
import FilterListIcon from '@mui/icons-material/FilterList';

import {
    Button,
    // FormControl,
    Grid,
    // InputLabel,
    // MenuItem,
    Paper,
    // Select,
    TextField,
    useTheme,
} from "@material-ui/core";

import Title from "./Title";
import { i18n } from "../../translate/i18n";

import ModernDatePicker from "../../components/ModernDatePicker";
import moment from "moment";

const Filters = ({
    classes,
    setDateStartTicket,
    setDateEndTicket,
    dateStartTicket,
    dateEndTicket,
    setQueueTicket,
    queueTicket,
    fetchData
}) => {
    const theme = useTheme();
    // const { user } = useContext(AuthContext);

    const [
        queues,
        // setQueues
    ] = React.useState(queueTicket);
    const [dateStart, setDateStart] = React.useState(dateStartTicket);
    const [dateEnd, setDateEnd] = React.useState(dateEndTicket);
    const [fetchDataFilter, setFetchDataFilter] = React.useState(false)

    return (
        <Grid item xs={12}>
            <Paper 
                className={classes.customFixedHeightPaperLg} 
                elevation={6}
                style={{
                    backgroundColor: theme.mode === 'light' ? "white" : "hsl(270, 25%, 10%)",
                    color: theme.mode === 'light' ? "inherit" : "hsl(0, 0%, 95%)",
                    padding: "20px",
                }}
            >
                <Title>Filtros</Title>
                <Grid container spacing={3}>
                    {/* <Grid item xs={12} sm={6} md={3}>
                        <FormControl fullWidth>
                            <InputLabel id="queue-label">
                                Departamentos
                            </InputLabel>
                            <Select
                                labelId="queue-label"
                                id="queue-select"
                                defaultValue={queueTicket}
                                label="Departamentos"
                                onChange={(e) => setQueues(e.target.value)}
                            >
                                <MenuItem value={false}>
                                    Todos os Departamentos
                                </MenuItem>
                                {user.queues.map((queue) => (
                                    <MenuItem key={queue.id} value={queue.id}>
                                        {queue.name}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </Grid> */}

                    <Grid item xs={12} sm={6} md={5}>
                        <ModernDatePicker
                            label={i18n.t("dashboard.date.initialDate")}
                            value={dateStart ? moment(dateStart).toDate() : null}
                            onChange={(newValue) => setDateStart(moment(newValue).format("YYYY-MM-DD"))}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6} md={5}>
                        <ModernDatePicker
                            label={i18n.t("dashboard.date.finalDate")}
                            value={dateEnd ? moment(dateEnd).toDate() : null}
                            onChange={(newValue) => setDateEnd(moment(newValue).format("YYYY-MM-DD"))}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6} md={2}>
                        <Button
                            fullWidth
                            variant="contained"
                            startIcon={<FilterListIcon />}
                            style={{
                                color: "white",
                                backgroundColor: theme.mode === 'light' ? "#228B22" : "hsl(270, 80%, 60%)",
                                boxShadow: "none",
                                borderRadius: "10px",
                                textTransform: "none",
                                fontWeight: 600,
                            }}
                            onClick={() => {
                                setQueueTicket(queues);
                                setDateStartTicket(dateStart);
                                setDateEndTicket(dateEnd);
                                setFetchDataFilter(!fetchDataFilter)
                                fetchData(!fetchDataFilter);
                            }}
                        >
                            Filtrar
                        </Button>
                    </Grid>
                </Grid>
            </Paper>
        </Grid>
    );
};

export default Filters;
